import Entity from '../entity'

export default class VipCard extends Entity<number>{
    name: string  = null;
    unitPrice: string  = null;
    validMonths: number  = null;
    discount: number  = null;
    tenantId: number  = null;
    cardImageUrl: string  = null;
    coin: number = 0;
    creationTime: string;
    remark: string  = null;

}